import cond from 'lodash/fp/cond';

import { ErrorMessage } from '../components/ErrorMessage';
import { MainPages } from '../pages/MainPages';

type MainContentProps = {
    data: unknown;
    hasFetchInitialDataFailed: boolean;
    hasFetchGroupsFailed: boolean;
    isMap: boolean;
    hasMapAlreadyLoaded: boolean;
};

export const MainContent = (props: MainContentProps) => {
    const { data, hasFetchInitialDataFailed, hasFetchGroupsFailed } = props;

    const hasErrors = () => (hasFetchInitialDataFailed && !data) || hasFetchGroupsFailed;
    const hasData = () => !hasErrors();

    const content = cond([
        [hasData, MainPages],
        [hasErrors, ErrorMessage],
    ])(props);

    return content;
};
